/* POSTIFULL v105 (2026-11-04) - Sepette sozlesme onayi · snippets/pf-sozlesme-onay.liquid
   - "Odeme" ([name=checkout]) tiklaninca ayni formdaki onay kutusu bossa checkout'a gitmez, uyari gosterir.
   - Kutu isaretlenince zaman damgasi hem formdaki gizli alana (attributes[_sozlesme_onay], odeme ile birlikte POST edilir)
     hem /cart/update.js ile sepete yazilir -> siparise "Ek ayrintilar" olarak gecer.
   - Sozlesme baglantilari sayfadan cikmadan <dialog> acar; "Okudum, onayliyorum" kutuyu isaretler.
   Yuklenme: sections/cart-drawer.liquid ust kisminda (her sayfada bir kez). */
(function () {
  'use strict';
  if (window.__pfSozlesme) return;
  window.__pfSozlesme = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function p2(n) { n = Math.floor(Math.abs(n)); return (n < 10 ? '0' : '') + n; }
  function stamp(box) {
    var d = new Date(), off = -d.getTimezoneOffset();
    var iso = d.getFullYear() + '-' + p2(d.getMonth() + 1) + '-' + p2(d.getDate()) + 'T' + p2(d.getHours()) + ':' +
      p2(d.getMinutes()) + ':' + p2(d.getSeconds()) + (off >= 0 ? '+' : '-') + p2(off / 60) + ':' + p2(off % 60);
    var yer = box.closest('cart-drawer') ? 'sepet cekmecesi' : 'sepet sayfasi';
    return iso + ' | OBF+MSS ' + (box.getAttribute('data-pfs-surum') || '') + ' | ' + yer;
  }
  function save(val) {
    try {
      fetch(root + 'cart/update.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { _sozlesme_onay: val } })
      }).catch(function () {});
    } catch (e) {}
  }
  function setState(box, on) {
    if (!box) return;
    var cb = box.querySelector('[data-pfs-cb]'), v = box.querySelector('[data-pfs-val]'), er = box.querySelector('[data-pfs-err]');
    var val = on ? stamp(box) : '';
    if (cb) cb.checked = on;
    if (v) v.value = val;
    box.classList.remove('is-err');
    if (er) er.hidden = true;
    save(val);
  }
  function boxFor(btn) {
    var form = btn.form || btn.closest('form');
    var box = form && form.querySelector('[data-pfs]');
    if (!box) {
      var scope = btn.closest('cart-drawer, .shopify-section--main-cart');
      box = scope && scope.querySelector('[data-pfs]');
    }
    return box;
  }
  function closeDlg(d) { if (d && d.open) d.close(); }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var op = t.closest('[data-pfs-open]');
    if (op) {
      var b = op.closest('[data-pfs]');
      var d = b && b.querySelector('[data-pfs-dlg="' + op.getAttribute('data-pfs-open') + '"]');
      if (d && typeof d.showModal === 'function') {
        e.preventDefault();
        e.stopPropagation();
        d.showModal();
        var body = d.querySelector('.pfs-dlg__body');
        if (body) body.scrollTop = 0;
      }
      return;
    }
    if (t.matches && t.matches('dialog.pfs-dlg')) { e.preventDefault(); e.stopPropagation(); closeDlg(t); return; }
    var cl = t.closest('[data-pfs-close]');
    if (cl) { e.preventDefault(); e.stopPropagation(); closeDlg(cl.closest('dialog')); return; }
    var ok = t.closest('[data-pfs-ok]');
    if (ok) { e.preventDefault(); e.stopPropagation(); closeDlg(ok.closest('dialog')); setState(ok.closest('[data-pfs]'), true); return; }
    if (t.closest('.pfs-dlg')) { e.stopPropagation(); return; }

    var btn = t.closest('[name="checkout"]');
    if (!btn) return;
    var box = boxFor(btn);
    if (!box) return;
    var cb = box.querySelector('[data-pfs-cb]');
    if (cb && cb.checked) {
      /* Odeme Yap'i once pf-adres.js (teslimat penceresi) yakalar ve /checkout'a kendisi gider; form POST edilmez.
         Bu yuzden onay kaydi sepete burada bir kez daha yazilir (sepet ozellikleri birlesir, pf-adres'inkileri silmez). */
      var v = box.querySelector('[data-pfs-val]');
      if (v && !v.value) v.value = stamp(box);
      if (v) save(v.value);
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    box.classList.remove('is-err');
    void box.offsetWidth;
    box.classList.add('is-err');
    var er = box.querySelector('[data-pfs-err]');
    if (er) er.hidden = false;
    var rc = box.getBoundingClientRect();
    if (rc.top < 0 || rc.bottom > window.innerHeight) {
      try { box.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) {}
    }
    if (cb) cb.focus({ preventScroll: true });
  }, true);

  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.matches || !cb.matches('[data-pfs-cb]')) return;
    setState(cb.closest('[data-pfs]'), cb.checked);
  });

  /* Pencere icindeki dokunma/kaydirma sepet cekmecesinin "asagi cekerek kapat" hareketini tetiklemesin (pf-cart.js),
     Esc yalniz pencereyi kapatsin, cekmeceyi degil. */
  ['touchstart', 'touchmove'].forEach(function (ev) {
    window.addEventListener(ev, function (e) {
      if (e.target && e.target.closest && e.target.closest('.pfs-dlg')) e.stopPropagation();
    }, { capture: true, passive: true });
  });
  window.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = document.querySelector('dialog.pfs-dlg[open]');
    if (!d) return;
    e.preventDefault();
    e.stopPropagation();
    closeDlg(d);
  }, true);
})();
